export const news = [
  {
    id: "news-01",
    title: "《夜勤病栋》续作定档：暗夜回响将于下月登陆院线",
    category: "资讯",
    date: "2024-09-18",
    author: "夜勤病栋编辑部",
    readingTime: "3 分钟",
    tags: ["定档", "续作", "黑泽凉介"],
    relatedFilmId: "night-ward-echoes",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20news%20banner%20of%20a%20premiere%20event%20poster%20wall%20in%20a%20dark%20cinema%20lobby%2C%20deep%20blue%20lighting%2C%20elegant%20moody%20atmosphere%2C%20no%20text%2C%20photographic&width=1200&height=675&seq=nightward-news-01&orientation=landscape",
    excerpt: "导演黑泽凉介确认，《夜勤病栋：暗夜回响》已完成后期制作，将于下月正式登陆全国院线，原班人马悉数回归。",
    content:
      "据发行方消息，继 2023 年《夜勤病栋》取得口碑与票房双丰收之后，续作《夜勤病栋：暗夜回响》已正式完成后期制作，并定档下月上映。导演黑泽凉介在采访中表示，续作并非简单地延续前作，而是把叙事重心从『发生了什么』转向『谁在阻止真相被听见』。影片仍由佐藤健一、中村由美领衔主演，渡边香织新加盟饰演关键角色。制片方同时透露，本次将采用更克制的镜头语言，减少不必要的惊吓桥段，把悬念落在人物关系上。"
  },
  {
    id: "news-02",
    title: "剧情解析：夜勤病栋里的『凌晨三点』到底意味着什么",
    category: "剧情解析",
    date: "2024-09-12",
    author: "影评人 · 沈砚",
    readingTime: "6 分钟",
    tags: ["剧情解析", "符号", "凌晨三点"],
    relatedFilmId: "night-ward-2023",
    cover: "https://readdy.ai/api/search-image?query=wall%20clock%20showing%20three%20o%20clock%20in%20a%20dark%20empty%20hospital%20corridor%2C%20moody%20cinematic%20lighting%2C%20cold%20blue%20tones%2C%20atmospheric%20fog%2C%20no%20text%2C%20photographic&width=1200&height=675&seq=nightward-news-02&orientation=landscape",
    excerpt: "『凌晨三点』在片中反复出现，它既是时间点，也是一整套关于沉默与见证的隐喻。本文逐层拆解这个符号的三重含义。",
    content:
      "在《夜勤病栋》里，凌晨三点一共出现了七次。第一次是凉太听见呼叫铃，最后一次是他主动走进七号病房。对熟悉医疗行业的人来说，凌晨三点是一天中人体机能最低谷、值守人手最少、也最容易出错的时段——它天然指向系统的脆弱。从叙事上看，三点又是一个介于『昨天』与『今天』之间的时间，属于所有不被记录的时刻。而第三次含义则更为私人：对凉太而言，三点是他决定不再沉默的那一刻。理解这个符号，是理解整部影片的关键。"
  },
  {
    id: "news-03",
    title: "第二季开播即登顶：夜勤病栋如何把单元剧拍出了电影感",
    category: "剧情解析",
    date: "2024-08-30",
    author: "夜勤病栋编辑部",
    readingTime: "5 分钟",
    tags: ["第二季", "剧评", "单元剧"],
    relatedFilmId: "night-ward-s2",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20empty%20hospital%20nurse%20station%20at%20night%20with%20warm%20desk%20lamp%2C%20moody%20blue%20tones%2C%20film%20still%20atmosphere%2C%20no%20text%2C%20photographic&width=1200&height=675&seq=nightward-news-03&orientation=landscape",
    excerpt: "十二集单元剧，却有着统一的美术与调度。本文从镜头、声音与结构三个角度，分析第二季为何口碑炸裂。",
    content:
      "第二季最大的变化，是把镜头从单一案件扩展到了整座医院的夜班群像，但单元剧最怕的就是风格散掉。这部剧的处理方式是：统一的色温、统一的机位高度、以及一个贯穿全季的配乐动机。每个单元的主人公不同，但摄影机始终保持在人眼高度，仿佛观众就站在走廊里旁观。声音设计同样克制，几乎不用配乐煽情，而是让监护仪的滴答声承担情绪。正是这些一致性，让十二个独立故事最终收束成一部完整的作品。"
  },
  {
    id: "news-04",
    title: "幕后特辑：手术戏是怎么拍的？剧组请来了真正的麻醉科医生",
    category: "资讯",
    date: "2024-08-15",
    author: "夜勤病栋编辑部",
    readingTime: "4 分钟",
    tags: ["幕后", "医疗顾问", "手术"],
    relatedFilmId: "surgery-3am",
    cover: "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20film%20set%20of%20an%20operating%20room%2C%20surgical%20lamps%20and%20monitors%2C%20cinematic%20blue%20lighting%2C%20documentary%20atmosphere%2C%20no%20text%2C%20photographic&width=1200&height=675&seq=nightward-news-04&orientation=landscape",
    excerpt: "《凌晨三点的手术》里那场长达四十分钟的手术戏，背后是三位医疗顾问与两百多次排练。我们和导演聊了聊。",
    content:
      "为了拍好这场核心手术戏，剧组提前两个月邀请麻醉科与心外科医生进入排练厅。演员需要学习真实的持械姿势、器械传递顺序，甚至是缝合时的呼吸节奏。导演 David Coleman 表示，观众也许分不清器械名称，但一定能感觉到『不对劲』，所以要尽量不给出那种破绽。最终成片里，这场戏以近乎一镜到底的方式呈现，成为全片紧张感最强的段落。"
  },
  {
    id: "news-05",
    title: "从无影灯下到静默走廊：夜勤题材为何突然爆发",
    category: "专题",
    date: "2024-07-28",
    author: "影评人 · 沈砚",
    readingTime: "7 分钟",
    tags: ["专题", "趋势", "夜勤题材"],
    relatedFilmId: "silent-corridor",
    cover: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20multiple%20dark%20hospital%20corridors%20fading%20into%20darkness%2C%20cold%20blue%20grey%20palette%2C%20abstract%20cinematic%20mood%2C%20layered%20composition%2C%20no%20text%2C%20photographic&width=1200&height=675&seq=nightward-news-05&orientation=landscape",
    excerpt: "近三年，围绕夜班与医院场景的影视作品数量翻了近一倍。这背后既有类型融合的推力，也有观众情绪的转向。",
    content:
      "医疗题材从来不是新类型，但『夜勤』这个时段被单独拎出来讨论，是最近两三年的事。一方面，夜晚自带悬疑属性，天然适合类型融合；另一方面，医院本身就是一个生死、规则与人情高度密集的空间。当观众对宏大叙事产生疲劳后，这种聚焦于具体岗位、具体时段的『小而密』叙事，恰好提供了另一种观看快感。本文梳理了该题材近年的代表作与演变路径。"
  },
  {
    id: "news-06",
    title: "《第七号病房》重映：一部被低估的旧楼恐怖片",
    category: "资讯",
    date: "2024-07-10",
    author: "夜勤病栋编辑部",
    readingTime: "3 分钟",
    tags: ["重映", "第七号病房", "恐怖"],
    relatedFilmId: "ward-seven",
    cover: "https://readdy.ai/api/search-image?query=old%20abandoned%20hospital%20wing%20with%20peeling%20paint%20and%20long%20shadow%2C%20dim%20light%20at%20the%20end%20of%20a%20hallway%2C%20eerie%20cinematic%20atmosphere%2C%20no%20text%2C%20photographic&width=1200&height=675&seq=nightward-news-06&orientation=landscape",
    excerpt: "时隔三年，《第七号病房》以修复版重新上映。它当年票房平平，如今却被重新讨论。",
    content:
      "《第七号病房》上映时并不算成功，但随后通过流媒体积累了大量讨论。影片最被称道的是它对『声音』的使用：全片几乎没有尖叫，恐惧感全部来自走廊的回声与门轴的摩擦。此次修复版不仅提升了画质，还补录了新的环境音轨。导演冈本诗织表示，重映版更接近她最初想要的效果。"
  },
  {
    id: "news-07",
    title: "深度长文：《玻璃病栋》如何用一间医院写出整个行业的困境",
    category: "专题",
    date: "2024-06-22",
    author: "特约撰稿 · 顾阑",
    readingTime: "9 分钟",
    tags: ["深度", "玻璃病栋", "行业"],
    relatedFilmId: "glass-ward",
    cover: "https://readdy.ai/api/search-image?query=modern%20glass%20office%20tower%20reflecting%20a%20cold%20night%20sky%2C%20sharp%20geometry%2C%20blue%20grey%20editorial%20photography%2C%20abstract%20corporate%20atmosphere%2C%20no%20text%2C%20photographic&width=1200&height=675&seq=nightward-news-07&orientation=landscape",
    excerpt: "透明，是这个时代最有效的遮蔽。我们从剧中的四个细节出发，聊聊它为什么能拍到行业痛处。",
    content:
      "《玻璃病栋》最精妙的设计，是让整栋医院都是玻璃幕墙。表面上一切公开透明，实际上每个角落都有人盯着你，于是所有人在表演『规范』。剧中的四次关键会议、两份被修改的采购单、以及一个始终没有露面的供应商，构成了对医疗商业化的完整观察。文章从这四个细节出发，讨论了剧作在专业性与可看性之间的平衡。"
  },
  {
    id: "news-08",
    title: "夜勤病栋片单：十二部适合深夜一口气看完的作品",
    category: "资讯",
    date: "2024-06-05",
    author: "夜勤病栋编辑部",
    readingTime: "5 分钟",
    tags: ["片单", "推荐", "深夜"],
    relatedFilmId: "white-night-ward",
    cover: "https://readdy.ai/api/search-image?query=stack%20of%20moody%20film%20posters%20on%20a%20dark%20table%20lit%20by%20a%20single%20lamp%2C%20cinematic%20warm%20cool%20contrast%2C%20editorial%20product%20photo%2C%20no%20text%2C%20photographic&width=1200&height=675&seq=nightward-news-08&orientation=landscape",
    excerpt: "从《静默走廊》到《白夜病房》，这十二部作品构成了理解夜勤题材的最好入口。",
    content:
      "如果你刚开始接触夜勤题材，这份片单会是一个不错的起点。我们按照从轻到重的顺序排列，把叙事相对温和、信息密度适中的作品排在前面，把结构复杂、心理压迫感较强的作品放在后面。每部作品都附有简短的观看建议与关键词，方便你按自己的节奏挑选。"
  }
];